import { render, staticRenderFns } from "./ConfigureRetrieve.vue?vue&type=template&id=0c73872d&scoped=true"
import script from "./ConfigureRetrieve.vue?vue&type=script&lang=js"
export * from "./ConfigureRetrieve.vue?vue&type=script&lang=js"
import style0 from "./ConfigureRetrieve.vue?vue&type=style&index=0&id=0c73872d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c73872d",
  null
  
)

export default component.exports